import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { World } from './World';

export class NpcSpawnService {
    private static readonly NPC_MODELS = [
        'assets/characters/terrance.glb',
        'assets/characters/simone.glb',
        'assets/characters/albert.glb',
        'assets/characters/brian.glb',
    ];

    private static readonly FEMALE_MODELS = new Set([
        'assets/characters/simone.glb',
    ]);

    private static readonly COP_MODELS = [
        'assets/characters/officer_2.glb',
    ];

    private lastModel: string | null = null;
    private lastCopModel: string | null = null;
    public loader = new GLTFLoader();

    constructor(private world: World) {}

    public isFemale(modelPath: string): boolean {
        return NpcSpawnService.FEMALE_MODELS.has(modelPath);
    }

    public pickModel(): string {
        const pool = NpcSpawnService.NPC_MODELS.length > 1
            ? NpcSpawnService.NPC_MODELS.filter(m => m !== this.lastModel)
            : NpcSpawnService.NPC_MODELS;

        const model = pool[Math.floor(Math.random() * pool.length)];
        this.lastModel = model;
        return model;
    }

    public pickCopModel(): string {
        const pool = NpcSpawnService.COP_MODELS.length > 1
            ? NpcSpawnService.COP_MODELS.filter(m => m !== this.lastCopModel)
            : NpcSpawnService.COP_MODELS;

        const model = pool[Math.floor(Math.random() * pool.length)];
        this.lastCopModel = model;
        return model;
    }
}